/* exported handleUrlSearchParams */
export const handleUrlSearchParams = function (config) {
  this.config = config;
  this.fields = [];
  this.params = {};

  if (typeof this.config.addEmptyFields === "undefined") {
    this.config.addEmptyFields = true;
  }

  // find all fields that are referenced
  if (!config.predefinedFields) {
    this.fields = this.config.form.querySelectorAll(this.config.fieldSelector);
  } else {
    // if predefinedFields exist, use this array of fields to render
    this.fields = config.predefinedFields;
  }

  // create renderers
  // a renderer should return an array that contains the key in the first item and the value in the second

  const _defaultRenderer = (field) => {
    return [field.getAttribute("name"), field.value];
  };

  const _checkboxRenderer = (field) => {
    const name = field.getAttribute("name");
    const valueUnchecked = field.getAttribute("data-value-unchecked");
    let value = 0;

    if (field.checked) {
      value = field.value;
    } else if (valueUnchecked) {
      value = valueUnchecked;
    }

    return [name, value];
  };

  const _radioRenderer = (field) => {
    if (field.checked) {
      const name = field.getAttribute("name");
      const value = field.value;

      return [name, value];
    }
  };

  this.renderSearchParams = () => {
    this.fields.forEach((field) => {
      let output = {};

      if (!this.config.addEmptyFields) {
        if (field.value === "") {
          return;
        }
      }
      switch (field.getAttribute("data-renderer")) {
        case "checkbox":
          output = _checkboxRenderer(field);
          break;
        case "radio":
          output = _radioRenderer(field);
          break;
        default:
          output = _defaultRenderer(field);
      }

      if (output) {
        this.params[output[0]] = output[1];
      }
    });
    return this.params;
  };
};
